export const FONTS = {
  Arial: 'Arial',
  ArialMTBlack: 'ArialMTBlack',
  AvenirMedium: 'Avenir-Medium',
  AvenirLTStdBlack: 'AvenirLTStd-Black',
  IowanOldStyleBTRoman: 'IowanOldStyleBT-Roman',
  AvenirRegular: 'Avenir Regular',
  AvenirHeavy: 'AvenirLTStd-Heavy',
};
